'use client'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import React, { useEffect, useMemo, useState } from 'react'

type Props = {

}

const OrderVente = ({  }: Props) => {

    const searchParams = useSearchParams() 
    const pathName = usePathname()
    const params = useMemo(() => new URLSearchParams(searchParams.toString()), [searchParams])
    const router = useRouter()

    const [order, setOrder] = useState('order[dateVente]=DESC')
    
    const handleSortChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {

        // suppression des paramètres de tri
        params.delete('order[dateVente]')
        params.delete('order[prix]')
        params.set('page', '1')
        
        // ajout du nouveau paramètre de tri
        params.append( e.target.value.split('=')[0], e.target.value.split('=')[1])
        
        setOrder(e.target.value)
        router.push(pathName + '?' + params.toString())
    };

    useEffect(() => {
        if (params.has('order[dateVente]')) {
            setOrder(`order[dateVente]=${params.get('order[dateVente]')}`)
        } else if (params.has('order[prix]')) {
            setOrder(`order[prix]=${params.get('order[prix]')}`)
        }
    }, [params])

    return (
        <>
            <label htmlFor="select-tri-vente">Trier par :</label>
            <select
                id='select-tri-vente'
                value={order}
                onChange={handleSortChange}
                className='w-full mt-2 rounded-md border border-zinc-300 bg-white text-zinc-700 focus:border-zinc-500 focus:ring-zinc-500 focus:ring-1 duration-700 hover:border-zinc-500 hover:ring-zinc-500 hover:ring-1 px-2 py-1'
            >
                <option value="order[dateVente]=ASC">
                    {`Date de vente + proche`}
                </option>
                <option value="order[dateVente]=DESC">
                    {`Date de vente + éloignée`}
                </option>
                <option value="order[prix]=ASC">
                    {`Prix croissant`}
                </option>
                <option value="order[prix]=DESC">
                    {`Prix décroissant`}
                </option>
            </select>
        </>
    )
}

export default OrderVente